module.exports = __webpack_public_path__ + "img/ost_login.500d7646.svg";